import { createSelector } from 'reselect';
import { NAME } from '../constants';

/* ************ Top level Selector ********************/
const getState = state => state[NAME];
const getEntities = createSelector(getState, state => state.entities);

export {
  getState,
  getEntities
};
